'use client';

import { createContext, useContext } from 'react';

export const FormModeContext = createContext<'popup' | 'page'>('page');
export const useFormMode = () => useContext(FormModeContext);
